var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgPatternn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 728,
    height: 447,
    viewBox: "0 0 728 447",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.07,
    clipPath: "url(#clip0_40_124)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_40_124",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -458,
    y: -2,
    width: 1642,
    height: 938
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1183.81 -2H-457.25V935.747H1183.81V-2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_40_124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1308.18 1058.67H-581.624V-124.924H1308.18L1308.18 1058.67ZM-579.181 1056.23H1305.74V-122.482H-579.181V1056.23Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306.96 406.595H-580.403V409.037H1306.96V406.595Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306.96 347.536H-580.403V349.978H1306.96V347.536Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306.96 288.479H-580.403V290.921H1306.96V288.479Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306.96 229.421H-580.403V231.863H1306.96V229.421Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306.96 170.364H-580.403V172.806H1306.96V170.364Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306.96 111.306H-580.403V113.748H1306.96V111.306Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306.96 52.2483H-580.403V54.6904H1306.96V52.2483Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.061 -123.703H676.619V1057.45H679.061V-123.703Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.866 -123.703H619.424V1057.45H621.866V-123.703Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.673 -123.703H562.231V1057.45H564.673V-123.703Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.482 -123.703H505.04V1057.45H507.482V-123.703Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.289 -123.703H447.847V1057.45H450.289V-123.703Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.096 -123.703H390.654V1057.45H393.096V-123.703Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.903 -123.703H333.461V1057.45H335.903V-123.703Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.711 -123.703H276.269V1057.45H278.711V-123.703Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.518 -123.703H219.076V1057.45H221.518V-123.703Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.324 -123.703H161.882V1057.45H164.324V-123.703Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.131 -123.703H104.689V1057.45H107.131V-123.703Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9391 -123.703H47.4971V1057.45H49.9391V-123.703Z",
    fill: "#B3B3B3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1641.5,
    height: 938,
    fill: "white",
    transform: "translate(-457.25 -2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPatternn);
export default __webpack_public_path__ + "static/media/bg-patternn.05fbf660791be9bde6663daedc0e5847.svg";
export { ForwardRef as ReactComponent };